<template>
  <v-dialog v-model="modallogin" max-width="600" max-height="98%" persistent>
    <button type="button" class="close" @click="modallogin = false">
          <span style="color:black;font-size:30px" aria-hidden="true">&times;</span>
    </button>
    <login-component v-if="tab[0].visible" @activeRegister="isActiveTabs"/>
    <register-login-component v-if="tab[1].visible" @activeLogin="isActiveTabs"/>
  </v-dialog>
</template>

<script>
import { EventBus } from '../../../helpers/eventbus/event-bus'
import LoginUsers from '../modulos/Usuarios/LoginUsers'
import registrousuarios from '../modulos/Usuarios/registrousuarios'
// Modelos
import {
    mapGetters,
    mapActions
} from 'vuex'
  export default {
      data () {
        return {
          tab:[
              {name:'',checked:false,visible:true},
              {name:'',checked:false,visible:false},
          ],
          dialog: false,
          modallogin:false,
          dialog2: false,
          dialog3:false,
        }
      },
      computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
      }),
      mounted(){
        EventBus.$on('goLogin', () =>{
          this.goLogin()
        })
        EventBus.$on('goRegister', () =>{
          this.goRegister()
        })
      },
      methods: {
        isActiveTabs:function(index){
            this.tab.forEach(element => {
                element.visible=false;
            });
            this.tab[index].visible=true;
        }, 

        goLogin(){
          this.modallogin = true
          this.isActiveTabs(0)
        },
        goRegister(){
          this.modallogin = true
          this.isActiveTabs(1)
        }
      },
      components:{
        'login-component':LoginUsers,
        'register-login-component':registrousuarios
      }

      
  }
</script>
<style>

.v-dialog--active::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.0);
	border-radius: 10px;
	background-color:#6366d6;
}

.v-dialog--active::-webkit-scrollbar
{
	width: 6px;
	background-color:#6366d6;
}

.v-dialog--active::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.0);
	background-color: #ffff;
}
</style>
